import React from "react";
import { Box, Typography, Chip, Skeleton } from "@mui/material";
import SubjectActionItem from './SubjectActionItem';

const RecommendedActions = ({
  topActionablePairs,
  view,
  isSubjectHighlighted,
  isAttributeHighlightingParent,
  handleSubjectClick,
  handleAttributeClick,
  formatCurrency,
  formatImpact,
  getSubjectImpactAction,
  currencySymbol,
  selectedBusiness,
  isLoading,
  selectedBusinesses,
}) => {

  if (isLoading) {
    return (
      <Box>
        {[...Array(10)].map((_, index) => (
          <Skeleton key={index} variant="rectangular" height={60} sx={{ mb: 2 }} />
        ))}
      </Box>
    );
  }

  if (!topActionablePairs || topActionablePairs.length === 0) {
    return (
      <Box>
        <Typography variant="body2" color="textSecondary" sx={{ textAlign: 'center', mt: 2 }}>
          No actions to show.
        </Typography>
      </Box>
    );
  }

  // Helper function to get the value for sorting based on the view
  const getSortValue = (pair, currentView) => {
    if (!pair || !pair.attribute) return 0;
    if (currentView === "Sales") {
      return Math.abs(pair.attribute.revenueImpact || 0);
    } else if (currentView === "Rating") {
      // Align with tooltip display which uses averageRating for Rating view
      return Math.abs(pair.attribute.averageRating || 0);
    }
    // Default to attribute.impact if view is not Sales or Rating
    return Math.abs(pair.attribute.impact || 0);
  };

  // Sort all actions by descending absolute impact value
  const sortedActions = topActionablePairs.sort((a, b) => getSortValue(b, view) - getSortValue(a, view));

  return (
    <Box>
      {sortedActions.map((pair) => (
        <SubjectActionItem
          key={pair.uniqueKey}
          subject={pair.subject}
          attributes={[pair.attribute]}
          view={view}
          isSubjectHighlighted={isSubjectHighlighted}
          isAttributeHighlightingParent={isAttributeHighlightingParent}
          handleSubjectClick={handleSubjectClick}
          handleAttributeClick={handleAttributeClick}
          formatCurrency={formatCurrency}
          formatImpact={formatImpact}
          getSubjectImpactAction={() => ''}
          currencySymbol={currencySymbol}
          selectedBusiness={selectedBusiness}
          selectedBusinesses={selectedBusinesses}
          hideIcon={true}
          insightsCount={pair.attribute.commentCount || 0}
        />
      ))}
    </Box>
  );
};

export default RecommendedActions; 